import type { ReactNode } from "react";
import { Button } from "./Button";
import { Icon, type IconName } from "./icons";
import { cx } from "./cx";
import s from "./skeleton.module.css";

export interface EmptyStateProps {
  icon: IconName;
  title: string;
  description?: string;
  /** The one action that fills this view. */
  action?: ReactNode;
  compact?: boolean;
}

export function EmptyState({ icon, title, description, action, compact }: EmptyStateProps) {
  return (
    <div className={cx(s.empty, compact && s.compact)}>
      <div className={s.tile}><Icon name={icon} /></div>
      <h2>{title}</h2>
      {description ? <p>{description}</p> : null}
      {action ? <div className={s.action}>{action}</div> : null}
    </div>
  );
}

export interface ErrorStateProps {
  title?: string;
  message: string;
  onRetry?: () => void;
  requestId?: string | null;
  compact?: boolean;
}

export function ErrorState({ title = "Something went wrong", message, onRetry, requestId, compact }: ErrorStateProps) {
  return (
    <div className={cx(s.empty, s.error, compact && s.compact)} role="alert">
      <div className={s.tile}><Icon name="alert" /></div>
      <h2>{title}</h2>
      <p>{message}</p>
      {onRetry ? <div className={s.action}><Button onClick={onRetry}>Retry</Button></div> : null}
      {requestId ? <p className={s.reqid}>Request {requestId}</p> : null}
    </div>
  );
}
